import { styled, Theme } from "@mui/material/styles";
import { Alert, Box, Typography } from "@mui/material";

export const AlertContainer = styled(Alert)(({ theme }: { theme: Theme }) => ({
  color: "#323232",
  borderColor: "#0FD9FF",
  borderRadius: "0.25rem",
  borderWidth: "0.0625rem",
  backgroundColor: "#D4F8FF",
  "& .MuiAlert-icon": {
    color: "#0FD9FF",
    alignItems: "center",
    fontSize: "1.5rem",
  },
}));

export const TitleContainer = styled(Typography)(
  ({ theme }: { theme: Theme }) => ({
    fontFamily: '"Inter", Helvetica',
    fontSize: "1rem",
    fontWeight: 600,
    color: "#323232",
    letterSpacing: "-0.3px",
    lineHeight: 1.4,
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  }),
);

export const DescriptionContainer = styled(Typography)(
  ({ theme }: { theme: Theme }) => ({
    fontFamily: '"Inter", Helvetica',
    fontSize: "0.8125rem",
    fontWeight: 400,
    color: "#323232",
    lineHeight: 1.5,
    margin: 0,
    marginTop: "0.5rem",
    padding: 0,
    letterSpacing: "0.2px",
  }),
);

export const CounterBox = styled(Box)(({ theme }: { theme: Theme }) => ({
  display: "flex",
  alignItems: "center",
  marginTop: "0.5rem",
  fontWeight: "bold",
}));

export const CounterText = styled(Typography)(
  ({ theme }: { theme: Theme }) => ({
    fontFamily: '"Inter", Helvetica',
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#323232",
    letterSpacing: "0.3px",
    margin: 0,
    padding: 0,
  }),
);
